import React from "react";

import momentjs from "moment";
import momentTZ from "moment-timezone";

import { MOMENTJS_TIME_FORMAT } from "Constants/constants";
import { Avatar } from "ds/Avatar";
import { Tooltip } from "ds/Tooltip";

import * as S from "./CommitListItem.styles";

type CommitProps = {
  date?: number;
  message?: string;
  name: string;
  userAvatar?: string;
  sha: string;
};

const Commit = ({
  userAvatar = "",
  date = 0,
  message,
  name,
  sha
}: CommitProps) => {
  const momentDate = momentjs(date * 1000);

  return (
    <S.CommitLayout key={sha}>
      <Tooltip tooltip={name} analyticId={name}>
        <Avatar
          userImage={userAvatar}
          userName={name}
          alt={name}
          size="small"
        />{" "}
      </Tooltip>
      <S.CommitSha>{sha.substring(0, 7)}</S.CommitSha>
      <S.CommitMessage>{message}</S.CommitMessage>
      {date && (
        <S.CommitDateLayout>
          <Tooltip
            tooltip={`UTC${momentTZ(momentDate).format("Z")}`}
            analyticId="commit_list_item_date"
          >
            {momentDate.format(MOMENTJS_TIME_FORMAT)}
          </Tooltip>
        </S.CommitDateLayout>
      )}
    </S.CommitLayout>
  );
};

export default Commit;
